<template>
    
    <div class="main">
        <c-panel>
            <form-ajuda :paramId="$route.params.id" v-on:onSubmitAjuda="onSubmitAjuda"></form-ajuda>
        </c-panel>
    </div>
    
</template>
<script>

import formAjuda from "./form"

export default {
    methods:{

        onSubmitAjuda(){

            this.$router.push('/admin/ajuda');  
        }
    },
    components:{ formAjuda }
}
</script>
